import { __assign, __extends } from "tslib";
import React, { PureComponent } from 'react';
import { compareDataFrameStructures, FieldType, getFieldColorModeForField, getFieldDisplayName, } from '@grafana/data';
import { AxisPlacement, DrawStyle, PointVisibility, ScaleDirection, ScaleOrientation, } from '../uPlot/config';
import { UPlotConfigBuilder } from '../uPlot/config/UPlotConfigBuilder';
import { UPlotChart } from '../uPlot/Plot';
import { preparePlotData } from '../uPlot/utils';
import { preparePlotFrame } from './utils';
var defaultConfig = {
    drawStyle: DrawStyle.Line,
    showPoints: PointVisibility.Auto,
    axisPlacement: AxisPlacement.Hidden,
};
var Sparkline = /** @class */ (function (_super) {
    __extends(Sparkline, _super);
    function Sparkline(props) {
        var _this = _super.call(this, props) || this;
        var alignedDataFrame = preparePlotFrame(props.sparkline, props.config);
        var data = preparePlotData(alignedDataFrame);
        _this.state = {
            data: data,
            alignedDataFrame: alignedDataFrame,
            configBuilder: _this.prepareConfig(alignedDataFrame),
        };
        return _this;
    }
    Sparkline.getDerivedStateFromProps = function (props, state) {
        var frame = preparePlotFrame(props.sparkline, props.config);
        if (!frame) {
            return __assign({}, state);
        }
        return __assign(__assign({}, state), { data: preparePlotData(frame), alignedDataFrame: frame });
    };
    Sparkline.prototype.componentDidUpdate = function (prevProps, prevState) {
        var alignedDataFrame = this.state.alignedDataFrame;
        var stateUpdate = {};
        if (prevProps.sparkline !== this.props.sparkline) {
            if (!alignedDataFrame) {
                return;
            }
            var hasStructureChanged = !compareDataFrameStructures(this.state.alignedDataFrame, prevState.alignedDataFrame);
            if (hasStructureChanged) {
                var configBuilder = this.prepareConfig(alignedDataFrame);
                stateUpdate = { configBuilder: configBuilder };
            }
        }
        if (Object.keys(stateUpdate).length > 0) {
            this.setState(stateUpdate);
        }
    };
    Sparkline.prototype.prepareConfig = function (data) {
        var _this = this;
        var _a, _b, _c;
        var theme = this.props.theme;
        var builder = new UPlotConfigBuilder();
        builder.setCursor({
            show: true,
            x: false,
            y: false,
        });
        // X is the first field in the alligned frame
        var xField = data.fields[0];
        builder.addScale({
            scaleKey: 'x',
            orientation: ScaleOrientation.Horizontal,
            direction: ScaleDirection.Right,
            isTime: false,
            range: function () {
                var sparkline = _this.props.sparkline;
                if (sparkline.x) {
                    if (sparkline.timeRange && sparkline.x.type === FieldType.time) {
                        return [sparkline.timeRange.from.valueOf(), sparkline.timeRange.to.valueOf()];
                    }
                    var vals = sparkline.x.values;
                    return [vals.get(0), vals.get(vals.length - 1)];
                }
                return [0, sparkline.y.values.length - 1];
            },
        });
        builder.addAxis({
            scaleKey: 'x',
            theme: theme,
            placement: AxisPlacement.Hidden,
        });
        for (var i = 0; i < data.fields.length; i++) {
            var field = data.fields[i];
            var config = field.config;
            var customConfig = __assign(__assign({}, defaultConfig), config.custom);
            if (field === xField || field.type !== FieldType.number) {
                continue;
            }
            var scaleKey = config.unit || '__fixed';
            builder.addScale({
                scaleKey: scaleKey,
                orientation: ScaleOrientation.Vertical,
                direction: ScaleDirection.Up,
                min: field.config.min,
                max: field.config.max,
            });
            builder.addAxis({
                scaleKey: scaleKey,
                theme: theme,
                placement: AxisPlacement.Hidden,
            });
            var colorMode = getFieldColorModeForField(field);
            var seriesColor = colorMode.getCalculator(field, theme)(0, 0);
            var pointsMode = customConfig.drawStyle === DrawStyle.Points ? PointVisibility.Always : customConfig.showPoints;
            builder.addSeries({
                scaleKey: scaleKey,
                theme: theme,
                fieldName: getFieldDisplayName(field, data),
                drawStyle: customConfig.drawStyle,
                lineColor: (_a = customConfig.lineColor) !== null && _a !== void 0 ? _a : seriesColor,
                lineWidth: customConfig.lineWidth,
                lineInterpolation: customConfig.lineInterpolation,
                showPoints: pointsMode,
                pointSize: customConfig.pointSize,
                pointColor: (_b = customConfig.pointColor) !== null && _b !== void 0 ? _b : seriesColor,
                fillOpacity: customConfig.fillOpacity,
                fillColor: (_c = customConfig.fillColor) !== null && _c !== void 0 ? _c : seriesColor,
            });
        }
        return builder;
    };
    Sparkline.prototype.render = function () {
        var _a = this.state, data = _a.data, configBuilder = _a.configBuilder;
        var _b = this.props, width = _b.width, height = _b.height, sparkline = _b.sparkline;
        return (React.createElement(UPlotChart, { data: data, config: configBuilder, width: width, height: height, timeRange: sparkline.timeRange }));
    };
    return Sparkline;
}(PureComponent));
export { Sparkline };
//# sourceMappingURL=Sparkline.js.map